import { TypeSelectedOption } from 'views/pages/survey/const';

export const helperFormatDataForCallAPI = (
  numberRecord: number,
  listLength: number,
  percentLimit: number,
  limitRecord?: number
) => {
  const percentRecordOfList = (numberRecord / listLength) * 100;

  if (percentRecordOfList >= 100) {
    return TypeSelectedOption.ALL;
  }
  if (
    Math.floor(percentRecordOfList) > percentLimit ||
    (limitRecord && numberRecord > limitRecord)
  ) {
    return TypeSelectedOption.MANY;
  }

  return TypeSelectedOption.LITTLE;
};

export const formatUniqueArrayList = (oldData: any[], newData: any[], fieldIDName: string) => {
  if (newData.length === 0) {
    return oldData;
  }
  const oldIDArray = oldData.reduce<string[]>((acc, cur) => {
    acc.push(cur[fieldIDName]);
    return acc;
  }, []);
  const formatNewData = newData.reduce((acc, cur) => {
    if (!oldIDArray.includes(cur[fieldIDName as keyof typeof cur])) {
      acc.push(cur);
    }
    return acc;
  }, []);
  const finalData = oldData.concat(formatNewData);
  return finalData;
};

export const formatUniqueArrayString = (oldData: string[], newData: string[]) => {
  if (oldData.length > 0 && newData.length > 0) {
    const formatNewData = newData.reduce<string[]>((acc, cur) => {
      if (!oldData.includes(cur)) {
        acc.push(cur);
      }
      return acc;
    }, []);
    const finalData = oldData.concat(formatNewData);
    return finalData;
  }
  return newData;
};
